import InteractiveList from './interactive_list';

export default InteractiveList;
